import { imageTransform } from '@qctsw/common'
import { contentRemoveTags, isClient } from '@qctsw/utils'
import { LOAD_STATE } from '@/shared/types'
import type { AllMediaResponse, MediaDetailResponse, NewsColumnPageResponse } from '@/server/types'
import { getAllMediaApi, getMediaDetailApi, getNewsColumnPageApi } from '@/server'
import type { COOP_MEDIA_TYPE_CODE } from '@/shared/constants'
import type { PaginationFn } from '@/composables/usePagination'
import { usePagination } from '@/composables/usePagination'
import { useGetRouteParam, useGetRouteQuery } from '@/shared/function'

export function logicAllMedia() {
  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const data = ref<Record<keyof typeof COOP_MEDIA_TYPE_CODE, AllMediaResponse> | null>(null)

  async function getData() {
    const res = await useLoadState({
      key: `全部媒体`,
      state,
      fn: getAllMediaApi,
    })

    if (res?.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getData,
  }
}

export function logicMediaDetail() {
  const id = useGetRouteParam('id', '')
  const page = useGetRouteQuery('page', '1')

  const state = ref<LOAD_STATE>(LOAD_STATE.INIT)
  const detailData = ref<MediaDetailResponse | null>(null)
  const pageData = ref<NewsColumnPageResponse[]>([])
  const pagination = shallowRef<PaginationFn | null>(null)
  const { setShareBase } = useShare()
  async function getMediaDetail() {
    const res = await useLoadState({
      key: `媒体详情`,
      state,
      fn: () => getMediaDetailApi(id.value),
    })

    if (res?.data) {
      detailData.value = res.data

      pagination.value = usePagination({
        type: 'pageNumber',
        key: '媒体文章列表',
        request: params => getNewsColumnPageApi({ ...params, mediaSourceName: detailData.value?.name }),
      })

      if (isClient) {
        // share
        setShareBase({
          url: window.location.href,
          title: `${detailData.value.name}`,
          content: contentRemoveTags(detailData.value.intro),
          images: [imageTransform(detailData.value.coverImgUrl, { width: 160, height: 160 })],
        })
      }
    }
  }

  async function getMediaArticleList(page: string | number = 1) {
    if (!pagination.value || Number.isNaN(Number(page)))
      return

    const { list } = await pagination.value.loadPaginationData(Number(page)) || {}

    if (!list)
      return
    pageData.value = list
  }

  useActivatedWatch(() => [
    watch(page, () => {
      getMediaArticleList(page.value)
      window.scrollTo(0, 0)
    }),
  ])

  return {
    id,
    page,

    state,
    detailData,
    pageData,
    pagination,
    getMediaDetail,
    getMediaArticleList,
  }
}
